module.exports = "{\r\n  \"appId\": \"1641636289493829\",\r\n  \"shareDialog\": {\r\n    \"href\": \"https://ins.ama.ab.ca/quote/business\",\r\n    \"picture\": \"https://ins.ama.ab.ca/quote/business/styles/images/preview-logo.png\",\r\n    \"title\": \"facebook.share-dialog.Free Online Business Insurance Quote\",\r\n    \"caption\": \"facebook.share-dialog.AMA Insurance\",\r\n    \"description\": \"facebook.share-dialog.Busy running your small business? Get an online Business Insurance quote in 5 minutes!\"\r\n  }\r\n}"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./app/js/portal/config/facebook.json
// module id = 497
// module chunks = 0